/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_Job_PositionsInputs */

const en_open_job_positions = /** @type {(inputs: Open_Job_PositionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Job Positions`)
};

const de_open_job_positions = /** @type {(inputs: Open_Job_PositionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offene Stellen`)
};

/**
* | output |
* | --- |
* | "Open Job Positions" |
*
* @param {Open_Job_PositionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const open_job_positions = /** @type {((inputs?: Open_Job_PositionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_Job_PositionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_open_job_positions(inputs)
	return en_open_job_positions(inputs)
});